import React from "react";
import { ErrorMessage } from "formik";
import { FaUser, FaCalendarAlt, FaCar, FaDiscord } from "react-icons/fa";
import FormField from "../components/FormField";
import RadioButton from "../components/RadioButton";

const fieldLabelClass = "flex items-center gap-2 text-sm font-semibold text-foreground select-none";

export const StepIdentite = () => (
  <div className="flex flex-col gap-2.5 step-enter">
    <div>
      <h2 className="text-base font-bold text-foreground">Identité</h2>
      <p className="text-xs text-muted-foreground mt-0.5">Qui es-tu ?</p>
    </div>

    {/* Pseudo + Discord — tous deux avec texte d'aide, même hauteur */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <FormField
        name="pseudo"
        label="Pseudo ImagiGeeks"
        icon={FaUser}
        required
        help="Pour ta carte de membre et nos réseaux sociaux."
      />
      <FormField
        name="idDiscord"
        label="Pseudo Discord"
        icon={FaDiscord}
        required
        help="Pour t'inviter sur notre serveur Discord."
      />
    </div>

    {/* Nom/Prénom/Date sans texte d'aide — même hauteur, alignés sur une ligne */}
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      <FormField name="nom" label="Nom" icon={FaUser} required />
      <FormField name="prenom" label="Prénom" icon={FaUser} required />
      <FormField name="dateNaissance" label="Date de naissance" icon={FaCalendarAlt} type="date" required />
    </div>

    {/* Véhiculé */}
    <div className="flex flex-col gap-1.5">
      <label className={fieldLabelClass}>
        <FaCar className="h-4 w-4" style={{ color: "var(--acc)" }} />
        Véhiculé.e <span style={{ color: "var(--req)" }} className="font-bold">*</span>
      </label>
      <div className="flex gap-1.5 flex-wrap">
        {["Oui", "Non"].map((o) => (
          <RadioButton key={o} name="vehicule" value={o} label={o} />
        ))}
      </div>
      <p className="field-hint">Nous aide à organiser le covoiturage vers nos événements.</p>
      <ErrorMessage name="vehicule" component="p" className="field-err" />
    </div>
  </div>
);
